import { render, staticRenderFns } from "./DictionaryCreateFrom.vue?vue&type=template&id=961a4a0a&scoped=true&"
import script from "./DictionaryCreateFrom.vue?vue&type=script&lang=js&"
export * from "./DictionaryCreateFrom.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryCreateFrom.vue?vue&type=style&index=0&id=961a4a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961a4a0a",
  null
  
)

export default component.exports